var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 2,
    fill: "#0078D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8639 7.65609C18.0533 7.85704 18.0439 8.17348 17.8429 8.36288L9.91309 15.8368C9.67573 16.0605 9.30311 16.0536 9.07417 15.8213L6.39384 13.1009C6.20003 12.9042 6.20237 12.5877 6.39907 12.3938C6.59578 12.2 6.91235 12.2024 7.10616 12.3991L9.51192 14.8407L17.1571 7.63517C17.358 7.44577 17.6745 7.45513 17.8639 7.65609Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.bff702750f96a4e0a744403ad07216f1.svg";
export { ForwardRef as ReactComponent };